import { Platform } from 'react-native';

import { client } from '..';
import { GiftListResponse, GiftShowsBody } from '../models/giftShowModels';

export const getGifts = async ({
  queryKey,
  pageParam
}: {
  queryKey: (string | undefined)[];
  pageParam: string;
}): Promise<GiftListResponse> => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, n] = queryKey;

  const url = `/gifts/scrolling?n=${pageParam}`;

  const { data } = await client.get(url);

  return data;
};

export const purchaseGifts = async ({ showId, key, paymentMethod, phones }: GiftShowsBody): Promise<any> => {
  const url = `/gifts/purchase`;
  const { data } = await client.post(url, {
    showId,
    key,
    paymentMethod,
    phones,
    source: Platform.OS === 'web' ? 'BS_WEB' : 'BS_MOBILE'
  });

  return data;
};
